/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('SalesFilterController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterFactory,
		FindAllSalesFiltersByQueryParamsFactory,
		NoPagingSalesFilterFactory,
		NoPagingSalesStatusFactory,
		NoPagingUserFactory
	) {
		$scope.salesFilterList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilter)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilter);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilter = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('salesfilter.list.new');
		};

		$scope.goToEditState = function(salesFilter) {
			// this overview is NOT mapped, it is the main overview
			$state.go('salesfilter.list.edit', { salesFilterId: salesFilter.id });
		};

		var getUserId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterSearchOverview.user)) {
				return $scope.SalesFilterSearchOverview.user.id;
			} else {
				return undefined;
			}
		};

		NoPagingSalesStatusFactory.query(function(result) {
			$scope.salesStatusList = result;
		});

		/**
		 * This function queries all entities of type User and checks if this SalesFilter dialog is called in the context of User.
		 * If this is the case, we detect the parent entity SalesFilter and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryUser = function() {
			return NoPagingUserFactory.query(function(result) {
				return result;
			});
		};
		$scope.userReferenceFilterList = $scope.queryUser();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.SalesFilterSearchOverview = angular.copy($scope.SalesFilterSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilter = angular.copy($scope.pageSize);

			FindAllSalesFiltersByQueryParamsFactory.query(
				{
					page: $scope.SalesFilterSearchOverview.page - 1,
					size: $scope.pageSize,
					description: $scope.SalesFilterSearchOverview.description,
					firstName: $scope.SalesFilterSearchOverview.firstName,
					lastName: $scope.SalesFilterSearchOverview.lastName,
					potentialFromFrom: $scope.SalesFilterSearchOverview.potentialFromFrom,
					potentialFromTo: $scope.SalesFilterSearchOverview.potentialFromTo,
					potentialToFrom: $scope.SalesFilterSearchOverview.potentialToFrom,
					potentialToTo: $scope.SalesFilterSearchOverview.potentialToTo,
					offsetStartDateFromFrom: $scope.SalesFilterSearchOverview.offsetStartDateFromFrom,
					offsetStartDateFromTo: $scope.SalesFilterSearchOverview.offsetStartDateFromTo,
					offsetStartDateToFrom: $scope.SalesFilterSearchOverview.offsetStartDateToFrom,
					offsetStartDateToTo: $scope.SalesFilterSearchOverview.offsetStartDateToTo,
					salesStatus: $scope.SalesFilterSearchOverview.salesStatus,
					userId: getUserId(),

					sort: [$scope.SalesFilterSearchOverview.predicate + ',' + ($scope.SalesFilterSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isSalesFilterSearchOverviewDirty = function() {
			return !angular.equals($scope.SalesFilterSearchOverview, $scope.originalSalesFilterSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.SalesFilterSearchOverview = {};
			$rootScope.SalesFilterSearchOverview.page = 1;
			$rootScope.SalesFilterSearchOverview.predicate = 'id';
			$rootScope.SalesFilterSearchOverview.ascending = false;

			$scope.SalesFilterSearchOverview = angular.copy($rootScope.SalesFilterSearchOverview);

			$scope.originalSalesFilterSearchOverview = angular.copy($scope.SalesFilterSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.SalesFilterSearchOverview) || $rootScope.SalesFilterSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.SalesFilterSearchOverview = angular.copy($rootScope.SalesFilterSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedSalesFilterId = id;
			$('#deleteSalesFilterConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			SalesFilterFactory.delete(
				{ id: $scope.selectedSalesFilterId },
				function() {
					$scope.search();
					$('#deleteSalesFilterConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteSalesFilterConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.SalesFilterSearchOverview.predicate === itemName) {
				if ($scope.SalesFilterSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
